
import { Component, Emit, Prop } from '@modules/vue-property-decorator';
import Vue from 'vue';

@Component
export default class CircleIcon extends Vue {
    @Prop({ required: false, default: '#0000000d'}) private backgroundColor!: string;

    private get style() {
        return {
            backgroundColor: this.backgroundColor,
        };
    }
    private get clickable(): boolean {
        return !!this.$listeners['click'];
    }

    @Emit('click')
    private onClick(event: MouseEvent) {
        return event;
    }
}
